export const work_mode_options = [
  {
    label: "Jednoosobowy — pakowanie i pikowanie jednego wózka",
    value: 0,
  },
  { label: "Wieloosobowy — piker", value: 1 },
  { label: "Wieloosobowy — paker", value: 2 },
  {
    label: "Wieloosobowy — piker/paker (paker lotny)",
    value: 3,
  },
];

export const work_mode_options_text = [
  {
    label: "Jednoosobowy — pakowanie i pikowanie jednego wózka",
    value: "solo",
  },
  { label: "Wieloosobowy — piker", value: "picker" },
  { label: "Wieloosobowy — paker", value: "packer" },
  {
    label: "Wieloosobowy — piker/paker (paker lotny)",
    value: "floating_packer",
  },
];

export const getWorkModeName = (work_mode) =>
  work_mode_options_text.find(({ value }) => value === work_mode)?.label;

export default work_mode_options;
